import { render, staticRenderFns } from "./ReportingPeriod.vue?vue&type=template&id=65ace5e0&"
import script from "./ReportingPeriod.vue?vue&type=script&lang=ts&"
export * from "./ReportingPeriod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports